module.exports = __webpack_public_path__ + "static/media/x-button.94755993.svg";